export const partners = [
  {
    name: "University of Bath",
    href: "https://www.bath.ac.uk/announcements/pioneering-ai-tool-predicts-building-emissions-from-simple-text-descriptions/",
    logoLight: "/assets/images/partners/university-of-bath-slate.png",
    logoDark: "/assets/images/partners/university-of-bath-white.png",
  },
  {
    name: "Zebra",
    href: "https://www.zebra-model.org/",
    logoLight: "/assets/images/partners/zebra.png",
    logoDark: "/assets/images/partners/zebra.png",
    invertInDarkMode: true,
  },
];
